import { router } from "@inertiajs/react";
import { OpenInNew } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";

import CompensationList from "../../components/compensations/CompensationList";
import AcceptedCount from "../../components/events/AcceptedCount";
import Container from "../../components/layout/Container";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import Heading from "../../components/theme/Heading";
import { formatDate } from "../../lib/format";
import { Event } from "../../types/Event";

const Show = ({
  acceptedCount,
  compensations,
  coverUrl,
  description,
  future,
  link,
  locationHuman,
  name,
  slug,
  startsAt,
}: Event) => {
  return (
    <>
      <MetaData
        description={`Vraag reiskosten vergoeding voor ${name} of betaal die van een demonstrant.`}
        title={name}
      />
      <Main>
        <Box
          sx={{
            gap: "1em",
            display: "flex",
            flexDirection: "row",
            marginTop: { xs: 0, sm: "2em" },
          }}
        >
          <Box flexGrow={1}>
            <Heading component="h1" variant="h1">
              {name}
            </Heading>
            <Typography
              sx={{ marginTop: "0.2em", color: "primary.main" }}
              variant="h3"
            >
              {formatDate(startsAt)}, {locationHuman}
            </Typography>
            <Typography
              component="div"
              sx={{ marginTop: "1em" }}
              variant="body1"
            >
              {parse(description)}
            </Typography>
            {link && (
              <Button
                color="secondary"
                endIcon={<OpenInNew />}
                href={link}
                sx={{ marginTop: "1em" }}
                target="_blank"
                variant="contained"
              >
                Website
              </Button>
            )}
          </Box>
          <Box
            sx={{
              width: "25%",
              flexShrink: 0,
              display: { xs: "none", sm: "block" },
            }}
          >
            <Box
              alt={name}
              component="img"
              src={coverUrl}
              sx={{ width: "100%" }}
            />
          </Box>
        </Box>
      </Main>
      <Container sx={{ marginTop: { xs: "2em", sm: "4em" } }}>
        <CompensationList
          compensations={compensations}
          eventId={slug}
          future={future}
          refreshList={() => router.reload()}
        />
        <Box marginTop="2em" maxWidth={500}>
          <AcceptedCount count={acceptedCount} />
        </Box>
      </Container>
    </>
  );
};

export default Show;
